<script>
import wtTransform from '../transition'
// 组件class前缀
const prefixCls = 'wt-toggle'

export default {
  name: 'wt-toggle',
  props: {
    value: {
      type: Boolean,
      default: undefined
    },
    transition: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // 向slots元素添加key，这是为了在transition为true时，使过渡生效
    this.$slots.active[0].key = this.$slots.active[0].key || 'active'
    this.$slots.default[0].key = this.$slots.default[0].key || 'default'
  },
  render (h) {
    if (this.transition) {
      return h(wtTransform, {
        nativeOn: {
          click: this.clickHandler
        }
      }, this.currentDOM)
    } else {
      return h('div', {
        on: {
          click: this.clickHandler
        }
      }, this.currentDOM)
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    activeDOM () {
      return this.$slots.active
    },
    defaultDOM () {
      return this.$slots.default
    },
    currentDOM () {
      return this.activeStatus ? this.activeDOM : this.defaultDOM
    }
  },
  data () {
    return {
      activeStatus: this.value === undefined ? false : this.value
    }
  },
  watch: {
    value () {
      this.activeStatus = this.value
    }
  },
  methods: {
    clickHandler () {
      this.activeStatus = !this.activeStatus
      this.$emit('input', this.activeStatus)
    }
  }
}
</script>

<style lang="less">
.wt-toggle{
    display:inline-block;
}

.page-enter-active,
.page-leave-active {
  transition: opacity .2s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>
